import { render } from "./HelpcategoriesIndex.vue?vue&type=template&id=78a704cc"
import script from "./HelpcategoriesIndex.vue?vue&type=script&lang=js"
export * from "./HelpcategoriesIndex.vue?vue&type=script&lang=js"

import "./HelpcategoriesIndex.vue?vue&type=style&index=0&id=78a704cc&lang=css"

import exportComponent from "/var/www/html/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__